module.exports = __webpack_public_path__ + "static/media/bhaaa_chandrabindu.66cd45fd.ogg";